import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import classNames from 'classnames';
import dataTests from '../global/data-tests';
import styles from './button-toolbar.css';
/**
 * @name Button Toolbar
 */
export default class ButtonToolbar extends PureComponent {
    render() {
        const { className, 'data-test': dataTest, ...restProps } = this.props;
        const classes = classNames(styles.buttonToolbar, className);
        return _jsx("div", { ...restProps, "data-test": dataTests('ring-button-toolbar', dataTest), className: classes });
    }
}
